module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('i', [_c('b', [_vm._v("Contents")])])])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/series_introduction"
    }
  }, [_c('i', [_vm._v("Series Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/newpreface"
    }
  }, [_c('i', [_vm._v("Preface, 2014")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frantmatter01"
    }
  }, [_c('i', [_vm._v("Preface, 1969")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_c('i', [_vm._v("1 The Social Structure of Abortion in America")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("2 The Design of the Research")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch02_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Channels of Recruitment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch02_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Data Collection")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("3 The Characteristics of the Volunteers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Age and Marital Status")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Household Composition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Residence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Education")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Occupation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Attitudes toward Abortion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Personal Histories")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Motivation for Volunteering for This Study")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("4 The Unwanted Conception and the Decision")]), _vm._v(" "), _c('i', [_vm._v("to Seek Abortion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch04_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sexual Relationship in Which Conception Occurred")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch04_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contraceptive Practice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch04_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recognition of Pregnancy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch04_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Methods of Abortion Considered and Attempted")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch04_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confirming the Pregnancy and Consulting a Doctor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch04_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Consulting the Man Involved in the Pregnancy and Reasons for Terminating the Pregnancy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch04_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Persons Consulted about the Decision")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch04_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("5 The Search for an Abortionist")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Criterion for Inclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Units")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Relevant Information per Unit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inclusion of Abortionists")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Length of Chains")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Multiple Suggestions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contacts Mentioned after the Abortionist Was Located")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Results of the Searches")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("6 The Abortion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch06_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Self-induced Abortions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch06_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Catheter-type Abortions, Not Self-induced")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch06_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Illegal D. and C. Operations, without Anesthesia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch06_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Illegal D. and C. Operations, with Complete Anesthesia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch06_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Legally Performed “Therapeutic Abortions”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch06_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Comparison of the Types of Abortion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch06_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("7 Aftereffects of the Abortion and the Return")]), _vm._v(" "), _c('i', [_vm._v("to Normality")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Physical Recovery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psychological Recovery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Routine Medical Aftercare")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Changes in Contraceptive Use")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Changes in the Relationship with the Man Involved in the Pregnancy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Changes in Other Relationships")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coming to Terms with the Experience")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Control of Communication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Schedule of Recovery from Effects of the Abortion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Second and Higher-Order Abortions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("8 The Flow of Information through the")]), _vm._v(" "), _c('i', [_vm._v("Population as a Whole")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch08_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Social Structure of Acquaintance Networks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch08_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Social Structure of Abortion Communication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch08_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scope of Message Transmission")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch08_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Channels of Message Transmission: Barriers to the Flow of Information")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch08_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Communication through Formal Channels")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("9 Differential Access to Abortion and")]), _vm._v(" "), _c('i', [_vm._v("Abortionists")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch09_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When Is a Pregnancy Defined as Unwanted?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch09_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Choice of Abortion as Opposed to Alternative Responses to Unwanted Pregnancy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch09_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Social Class and the Outcome of Unwanted Pregnancies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch09_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Access to Various Kinds of Abortions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch09_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Access to Legal Hospital Abortions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch09_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Access to D. and C. Abortions Performed by a Physician with Anesthesia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch09_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Access to D. and C. Abortions Performed without Anesthesia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch09_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Access to Medically Untrained Abortionists")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch09_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Access to Self-induced Abortions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch09_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Access to Abortion and Abortionists: Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Appendix of Research Instruments")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/endmatter011"
    }
  }, [_vm._v("Model of Letter to Referring Agencies and Individuals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/endmatter012"
    }
  }, [_vm._v("Model Questionnaire Form")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Table",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("List of Tables and Figures")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d7b0912","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/content.vue
// module id = 66
// module chunks = 0